export const terminationReasonRouteName = {
  index: "terminationReasons.index",
};

export const terminationReasonRoute = [
  {
    path: "/termination-reasons",
    name: terminationReasonRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_reason",
      breadcrumbs: () => {
        return [{ title: "Termination Reason" }];
      },
    },
  },
];
